<template>
  <v-dialog v-model="dialog" max-width="420" persistent>
    <v-card>
      <v-card-title class="ae-title py-3 px-4">
        <v-icon small color="indigo darken-2" class="mr-2">mdi-swap-horizontal-circle-outline</v-icon>
        {{ obj.xtitle }}
        <v-spacer />
        <v-btn icon small @click="dialog = false"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4 pb-2 px-4 text-center ae-body">
        {{ obj.xbody }}
      </v-card-text>
      <Alertas
        ref="alertar"
        v-bind:msgSuccess="'El cambio de estado se realizó satisfactoriamente.'"
        v-bind:msgLoading="'Aplicando...'"
      />
      <v-divider />
      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn small text @click="dialog = false">Cerrar</v-btn>
        <v-btn v-if="activo" small depressed color="indigo darken-1" dark :loading="loading" @click="submit">
          <v-icon left small>mdi-check</v-icon> Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Alertas from '@/components/AAlertas.vue';

export default {
  components: { Alertas },
  props: {
    obj: { // {xid:Number, xtitle:String, xbody:String, xsql:Object}
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      activo: true,
      loading: false,
    };
  },
  watch: {
    'obj.xid': function() {
      if (this.obj.xid == null) return;
      setTimeout(() => {
        if(this.$refs.alertar){
            this.$refs.alertar.reset();
        }
      }, 800);
      this.activo = true;
    },
    'obj': function() {
      setTimeout(() => {
        if(this.$refs.alertar){
            this.$refs.alertar.reset();
        }
      }, 800);
      this.activo = true;
    },
  },
  methods: {
    open() {
      
      this.activo = true;
      this.loading = false;
      this.dialog = true;

      setTimeout(() => {
        if(this.$refs.alertar){
            this.$refs.alertar.reset();
        }
      }, 1800);
    },
    submit() {
      var vue = this;
      if (vue.obj.xid == 31) {
        let men = { title: 'MENSAJE', body: 'Este usuario no puede ser eliminado o cambiado de estado.' };
        this.$dialog.alert(men).then(function() {}).catch(function() {});
        return;
      }
      vue.$refs.alertar.cargando();
      vue.activo = false;
      vue.loading = true;
      this.$apollo.mutate({
        mutation: vue.obj.xsql,
      }).then(() => {
        vue.loading = false;
        vue.$refs.alertar.success();
        vue.dialog = false;
        this.$emit('exito');
      }).catch((error) => {
        window.console.error(error);
        vue.loading = false;
        vue.$refs.alertar.invalido();
      });
    },
  },
};
</script>

<style scoped>
.ae-title {
  font-size: 0.9rem !important;
  font-weight: 700 !important;
  color: #283593;
  border-bottom: 1px solid #e8edf7;
}
.ae-body {
  font-size: 0.88rem;
  color: #37474f;
  line-height: 1.5;
}
</style>
